import React from 'react';
import { CheckCircleIcon, UserIcon } from 'lucide-react';
interface TestimonialCardRlt2Props {
  name: string;
  location: string;
  duration: string;
  testimonial: string;
}
const TestimonialCardRlt2 = ({
  name,
  location,
  duration,
  testimonial
}: TestimonialCardRlt2Props) => {
  return <div className="border-l-2 border-gray-800 pl-5 py-4 my-6 bg-gray-50 rounded-r shadow-sm" data-id="element-6770">
      <blockquote className="font-serif text-gray-700 italic mb-4 leading-relaxed text-base" data-id="element-6771">
        "{testimonial}"
      </blockquote>
      <div className="flex items-center border-t border-gray-200 pt-3" data-id="element-6772">
        <div className="w-6 h-6 rounded-full bg-gray-300 flex items-center justify-center mr-2" data-id="element-6773">
          <UserIcon className="h-3 w-3 text-gray-600" data-id="element-6774" />
        </div>
        <div className="text-sm text-gray-600" data-id="element-6775">
          <span className="font-medium text-gray-800" data-id="element-6776">{name}</span>
          <span className="mx-1" data-id="element-6777">•</span>
          <span data-id="element-6778">{location}</span>
          <span className="mx-1" data-id="element-6779">•</span>
          <span data-id="element-6780">Using product for {duration}</span>
        </div>
        <div className="ml-2 flex items-center text-green-600 text-xs font-medium border border-green-200 rounded-full px-2 py-0.5 bg-green-50" data-id="element-6781">
          <CheckCircleIcon className="h-3 w-3 mr-1" data-id="element-6782" />
          <span data-id="element-6783">Verified</span>
        </div>
      </div>
    </div>;
};
export default TestimonialCardRlt2;